import { render, staticRenderFns } from "./TagV2.vue?vue&type=template&id=600df058&scoped=true&"
import script from "./TagV2.vue?vue&type=script&lang=js&"
export * from "./TagV2.vue?vue&type=script&lang=js&"
import style0 from "./TagV2.vue?vue&type=style&index=0&id=600df058&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600df058",
  null
  
)

export default component.exports